import { join, isEmpty, compact } from 'lodash';

function formatAddress(address) {
  if (!address) {
    return '';
  }
  const cityAndPC = `${address.city} ${address.postal_code}`;
  const addressItems = [
    isEmpty(address.line_1) ? undefined : address.line_1,
    isEmpty(address.line_2) ? undefined : address.line_2,
    cityAndPC,
  ];
  return join(compact(addressItems), ', ');
}

export default formatAddress;



// WEBPACK FOOTER //
// ./public/js/utils/formatAddress.js